import { all, fork, put, select, takeLatest } from '@redux-saga/core/effects';
import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import { GLOBALCONTENT_TYPE } from '../../constants/api';
import {
  createGlobalContentInitialize,
  removeGlobalContentWithIdFromStore,
} from '../actions/api';
import { allGlobalContentSelector } from '../apiFeatures/globalContentSlice';
import { parseApiError } from '../globalMessageSlice';
import { getAttr, getEntityId, getRelId } from '../helpers/apiHelpers';
import { awaitApiCall } from '../helpers/sagaHelpers';

// ---------- ACTIONS -----------
const saveChanges = createAction(
  'page/globalContentAdministration/saveChanges',
);
const setGlobalContentBeingSaved = createAction(
  'page/globalContentAdministration/saving',
);
// ---------- REDUCERS -----------
const GlobalContentAdministrationPageReducer = createReducer(
  { isSavingContent: false },
  (builder) => {
    builder.addCase(setGlobalContentBeingSaved, (state, action) => {
      state.isSavingContent = action.payload;
    });
  },
);
// ----------- Sagas -------------
export function* globalContentAdministrationPageSaga() {
  yield all([fork(createGlobalContentSaga)]);
}

function* createGlobalContentSaga() {
  yield takeLatest(saveChanges.type, function* (action) {
    yield put(setGlobalContentBeingSaved(true));
    const { globalContentTypeId, content } = action.payload;

    const newGlobalContent = {
      type: GLOBALCONTENT_TYPE,
      attributes: {
        content: content,
      },
      relationships: {},
    };

    const createGlobalContentInitAction = yield put(
      createGlobalContentInitialize({
        globalContentTypeId,
        data: newGlobalContent,
      }),
    );

    const createGlobalContentResult = yield awaitApiCall(
      createGlobalContentInitAction,
    );

    if (createGlobalContentResult.error) {
      yield put(parseApiError(createGlobalContentResult.error.payload));
    } else if (createGlobalContentResult.success) {
      const globalContents = yield select(allGlobalContentSelector);

      const currentVersionNumber =
        createGlobalContentResult.success.payload.requestData.data.attributes
          .version;

      const versionsToDelete = [];
      globalContents.forEach((globalContent) => {
        if (
          getRelId(globalContent, 'globalContentType') ===
            globalContentTypeId &&
          getAttr(globalContent, 'version') !== currentVersionNumber
        ) {
          versionsToDelete.push(getEntityId(globalContent));
        }
      });

      for (let i = 0; i < versionsToDelete.length; i++) {
        yield put(removeGlobalContentWithIdFromStore(versionsToDelete[i]));
      }
    }
    yield put(setGlobalContentBeingSaved(false));
  });
}

// ----------- Selectors -----------
const globalContentAdministrationState = (state) =>
  state.page.globalContentAdministration;

const isSavingContentSelector = createSelector(
  globalContentAdministrationState,
  (state) => state.isSavingContent,
);

export { saveChanges, isSavingContentSelector };
export default GlobalContentAdministrationPageReducer;
